import { RemixBrowser } from '@remix-run/react'
import ShopifyFormat from '@shopify/i18next-shopify'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { startTransition, StrictMode, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { getInitialNamespaces } from 'remix-i18next/client'
import i18nextOptions from './i18n/i18nextOptions'
import posthog from 'posthog-js'

function PosthogInit() {
  useEffect(() => {
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
      capture_pageview: true, // Enable automatic pageview tracking
      capture_pageleave: true, // Track when users leave pages
      persistence: 'localStorage',
      autocapture: true, // Automatically capture clicks, form submissions etc
      capture_exceptions: false,
    })
  }, [])

  return null
}

function hydrate() {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <I18nextProvider i18n={i18next}>
          <RemixBrowser />
          <PosthogInit />
        </I18nextProvider>
      </StrictMode>,
    )
  })
}

async function initI18n() {
  const localeVersion = window.ENV.HASH || Date.now()

  await i18next
    .use(initReactI18next)
    .use(ShopifyFormat.default || ShopifyFormat)
    .use(LanguageDetector)
    .use(Backend)
    .init({
      ...i18nextOptions,
      debug: window.ENV.NODE_ENV === 'development',
      ns: getInitialNamespaces(),
      backend: { loadPath: `/i18n/locales/{{lng}}/{{ns}}.json?v=${localeVersion}` },
      detection: {
        order: ['htmlTag'],
        caches: [],
      },
    })
}

initI18n().then(hydrate)
